import { NO_UPDATE_ERROR } from '../../../../utils/formValidation/commonErrorConstants';

export const INVALID_DUE_DATE = `Due date must be same as or after start date`;

export const initialErrorState = {};

export const validate = (participantBarriers) => {
    let newErrors = {};

    if (participantBarriers?.length < 1) {
        newErrors = { button: { error: true, message: NO_UPDATE_ERROR } };
    }

    const invalidDueDateBarriers = participantBarriers.filter((el) => el.dueDate < el.startDate);
    if (invalidDueDateBarriers?.length > 0)
        newErrors = { button: { error: true, message: INVALID_DUE_DATE } };

    return newErrors;
};
